import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationTableComponent } from './pagination/pagination-table/pagination-table.component';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { IconsPasswordComponent } from './components/icons-passwors/icons-password/icons-password.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

@NgModule({
  declarations: [
    PaginationTableComponent,
    ConfirmationDialogComponent,
    IconsPasswordComponent, 
  ],
  imports: [
    CommonModule,
    MatIconModule, 
    TranslateModule, 
    ButtonsModule.forRoot(), 
  ],
  exports:[
    PaginationTableComponent,
    ConfirmationDialogComponent,
    IconsPasswordComponent, 
  ],
  providers: [
  ]
})
export class SharedModule { }
